import { analytics, logEvent } from '../configs/firebase';

export class AnalyticsService {
  static trackPageView(pageName: string, pagePath?: string) {
    if (!analytics) {
      console.log('📊 Analytics not available, skipping page view tracking');
      return;
    }
    
    try {
      console.log('📊 Sending page view to Google Analytics:', pageName);
      logEvent(analytics, 'page_view', {
        page_title: pageName,
        page_location: pagePath || window.location.href,
        page_path: pagePath || window.location.pathname,
      });
    } catch (error) {
      console.warn('❌ Failed to track page view:', error);
    }
  }

  static trackEvent(eventName: string, parameters?: Record<string, any>) {
    if (!analytics) return;
    
    try {
      console.log('📊 Sending event to Google Analytics:', eventName, parameters);
      logEvent(analytics, eventName, parameters);
    } catch (error) {
      console.warn('❌ Failed to track event:', error);
    }
  }

  static trackUserAction(action: string, category: string, label?: string, value?: number) {
    if (!analytics) return;
    
    try {
      logEvent(analytics, 'user_action', {
        action,
        category,
        label,
        value,
      });
      
    } catch (error) {
      console.warn('Failed to track user action:', error);
    }
  }

  static trackSkinCheck(step: string, result?: any) {
    this.trackEvent('skin_check', {
      step,
      result: result ? JSON.stringify(result) : undefined,
    });
  }

  static trackChatMessage(messageType: 'user' | 'ai', messageLength: number) {
    this.trackEvent('chat_message', {
      type: messageType,
      length: messageLength,
    });
  }

  static trackLogin(method: string) {
    this.trackEvent('login', {
      method,
    });
  }
} 